/* eslint-disable @next/next/no-html-link-for-pages */
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import {
  Popover, Stack, Container, Box,
} from '@mui/material';
import { styled } from '@mui/system';
// import { VN as VNFlag } from 'country-flag-icons/react/3x2';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { MouseEvent, useEffect, useState } from 'react';
import ImgContainer from '../ImgContainer';
import Link from 'next/link';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { SEO_PAGE_TYPE } from '@/utils/constants';

export const BarWrapperDiv = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
  background: ${style.color.white4};
  position:relative;
`;

const StyledA = styled('a')`
  cursor: pointer;
  text-decoration: none;
  height: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  color: black;
  font-size: 14px;
  font-weight: 500;
  min-height: 60px;
  margin-left: 20px;
`;
const StyledAHover = styled(StyledA)({
  '&:hover': {
    color: style.primary.blue,
  },
});

const StyledASub = styled('a')`
  cursor: pointer;
  text-decoration: none;
  height: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  color: black;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 16px;
`;

const StyledASubHover = styled(StyledASub)({
  justifyContent: 'flex-start !important',
  alignItems: 'left !important',
  '&:hover': {
    background: '#e6f7ff',
  },
});

export const LANG = {
  vi: 'VN',
  en: 'EN',
};

export const LANG_EXTEND = {
  vi: 'vi',
  en: 'en',
};

const HeaderBarDesktop = ({ lang, airport, pageType }: { lang: ILangObj, airport?: any, pageType?: number }) => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState<HTMLAnchorElement | null>(null);
  const [langObj, setLangObj] = useState({
    lang: 'vi',
    viUrl: '',
    enUrl: '',
  });
  let airportLocaleNext = (airport?.localizations?.data || []).find((a: { locale: string; }) => a?.locale !== lang?.lang)?.attributes?.slug;
  let airportLocale = airport?.slug;
  const urlVEX = lang?.lang === 'en' ? `${process.env.VEX_URL}/en-US` : process.env.VEX_URL;
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };
  airportLocale = airportLocale?.replace('.en', '');
  airportLocaleNext = airportLocaleNext?.replace('.en', '');
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  useEffect(() => {
    // const currLang = router.asPath.split('.').pop();
    if (lang?.lang !== 'en') {
      const viUrl = router.asPath;
      const enUrl = viUrl.replace('ve-may-bay', 'flights')
        .replace('/tu-', '/from-')
        .replace('-di-', '-to-')
        .replace('-tu-', '-from-')
        .replace('/di-', '/to-')
        .replace('.vi', '.en')
        .replace(airportLocale, airportLocaleNext);
      setLangObj({
        lang: 'VN',
        viUrl,
        enUrl,
      });
    } else {
      const enUrl = router.asPath;
      const viUrl = enUrl.replace('flights', 've-may-bay')
        .replace('/from-', '/tu-')
        .replace('-to-', '-di-')
        .replace('-from-', '-tu-')
        .replace('/to-', '/di-')
        .replace('.en', '.vi')
        .replace(airportLocale, airportLocaleNext);
      setLangObj({
        lang: 'EN',
        viUrl,
        enUrl,
      });
    }
  }, []);
  return (
    <Box sx={{
      boxShadow: '0px 5px 5px rgba(213, 218, 221, 0.3)',
      zIndex: 1,
      width: '100%',
    }}
    >
      <Container>
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 1,
            width: '100%',
          }}
        >
          <a href={urlVEX || '/'}>
            <ImgContainer
              height={24}
              width={108}
              src="https://storage.googleapis.com/goyolo-uat/images/icon_vxr_full.svg"
              alt="logo"
              className="lazyload"
              style={{
                height: pr`33px`,
              }}
            />
          </a>
          <Stack
            direction="row"
            sx={{ flexWrap: 'wrap' }}
          >
            <StyledAHover href={lang?.menuDesktop?.[0]?.link}>
              {lang?.menuDesktop?.[0]?.title}
            </StyledAHover>
            <StyledAHover href={lang?.menuDesktop?.[1]?.link}>{lang?.menuDesktop?.[1]?.title}</StyledAHover>
            <StyledAHover href={lang?.menuDesktop?.[2]?.link}>{lang?.menuDesktop?.[2]?.title}</StyledAHover>
            <StyledAHover
              aria-describedby={id}
              onClick={handleClick}
            >
              {lang?.menuDesktop?.[3]?.title}
              <ArrowDropDownIcon sx={{
                fontSize: '16px !important',
                color: '#000',
              }}
              />
            </StyledAHover>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              sx={{
                marginTop: '-15px',
              }}
              disableScrollLock
            >
              <Stack
                justifyContent="flex-start"
              >
                <StyledASubHover href={lang?.menuDesktop?.[3]?.children?.[0]?.link}>{lang?.menuDesktop?.[3]?.children?.[0]?.title}</StyledASubHover>
                <StyledASubHover href={lang?.menuDesktop?.[3]?.children?.[1]?.link}>{lang?.menuDesktop?.[3]?.children?.[1]?.title}</StyledASubHover>
                <StyledASubHover href={lang?.menuDesktop?.[3]?.children?.[2]?.link}>{lang?.menuDesktop?.[3]?.children?.[2]?.title}</StyledASubHover>
              </Stack>
            </Popover>
            {(!airportLocaleNext && pageType === SEO_PAGE_TYPE.AIRPORT_PAGE) ? null : (
              <StyledAHover href={langObj.lang === LANG?.vi ? langObj.enUrl : langObj.viUrl}>
                {langObj.lang === LANG?.vi ? LANG?.en : LANG?.vi}
                <ImgContainer
                  src={langObj.lang === LANG?.vi ? 'https://storage.googleapis.com/fe-production/images/english_icon.png' : 'https://storage.googleapis.com/fe-production/images/vietnam_icon.png'}
                  width={20}
                  height={20}
                  alt="logo"
                  className="lazyload"
                />
              </StyledAHover>
            )}
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default HeaderBarDesktop;
